import React, {
  useContext,
  createRef,
  useState,
  useEffect,
  useMemo,
} from 'react';
import { DataGrid } from '../../../../../components/DataGrid/DataGrid';
import moment from 'moment-jalaali';
import { localText } from '../../../../../langs/fa/data-grid';
import formatNumber from '../../../../../fns/formatNumber';
import Avatar from '../../../../../components/User/UserAvatar';
import { useHistory } from 'react-router-dom';
import useRules from 'hooks/useRules';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import LinearProgress from '@material-ui/core/LinearProgress';
import useToast from 'hooks/useToast';
import CircularProgress from '@material-ui/core/CircularProgress';
import { store as mainStore } from '../../../../../store';
import YesNo from '../../../../../components/Dialog/YesNo';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from '../../../../../components/TextFields/DatePicker';
import SelectBank from '../../../../../components/FormInputs/SelectBank';
import { useValidator, TYPES } from '../../../../../hooks/useValidator';
import { useMain } from '../../../../../hooks/useMain';
import { __ } from '../../../../../utils/i18n';
import axios from '../../../../../api/axios';
import toEN from '../../../../../fns/toEn';
import validateCard from 'fns/checkShebaNumber';
import validateIranianSheba from 'fns/checkSheba';
import { banks } from 'utils/banks';
import { useDepositStore } from 'useStores/useDepositStore';
import { useSearchParams } from 'hooks/useSearchParams';
import { useMainStore } from 'useStores/useMainStore';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
  radio: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '& > *:not(:last-child)': {
      marginRight: 10,
    },
  },
  root: {
    '& .payBtn': {
      padding: '1rem',
    },
    '& .red': {
      color: 'red',
    },
    '& .green': {
      color: 'green!important',
    },
    '& .disable': {
      backgroundColor: '#dbd9d94f',
      color: '#737373bf',
      borderBottom: '1px solid #cbcbcbb5',
    },
  },
}));

const ref = createRef();

const List = () => {
  const classes = useStyles();
  const history = useHistory();
  const [rules, hasRule, isAdmin] = useRules();

  const limit = useMainStore((state) => state.limit);
  const [params, setParams] = useSearchParams();

  const initialValues = {
    bank: { label: 'نام بانک', value: 0 },
    shaba: '',
    refrenceNum: '',
    depositDate: moment(),
    sDate: moment(),
    eDate: moment(),
    amount: '',
    date: moment(),
  };
  const [values, setValues] = useState(initialValues);
  const validators = {
    bank: [{ type: TYPES.REQUIRED }],
    shaba: [{ type: TYPES.REQUIRED }],
    refrenceNum: [{ type: TYPES.REQUIRED }],
  };
  const [errors, validate] = useValidator(validators);
  const toast = useToast();

  const [loadingDepostit, setLoadingDeposit] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [modal, setModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const location = useLocation();
  const page = params.get('page') || 1;

  let statusTemp = false;

  const columns = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 90,
      cellClassName: (params) => (params.row.status ? 'disable' : ''),
    },
    {
      field: 'orderCount',
      headerName: 'تعداد',
      width: 90,
      cellClassName: (params) => (params.row.status ? 'disable' : ''),
    },
    {
      field: 'userName',
      headerName: 'کاربر',
      flex: 1,
      cellClassName: (params) => (params.row.status ? 'disable' : ''),
    },
    {
      field: 'companyCommissions',
      headerName: 'کارمزد شرکت',
      flex: 1,
      cellClassName: (params) => (params.row.status ? 'disable' : ''),
    },
    {
      field: 'userCommissions',
      headerName: 'کارمزد متعلقه',
      flex: 1,
      cellClassName: 'payBtn',
      height: 'fit-content',
      renderCell: (params) => (
        <Button
          disabled={!isMobile && params.row.status}
          className={!isMobile && (params.row.status ? 'disable' : 'red')}
        >
          {params.value}
        </Button>
      ),
      cellClassName: (params) => (params.row.status ? 'disable' : ''),
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      flex: 1,
      cellClassName: (params) => (params.row.status ? 'disable' : 'red'),

      renderCell: ({ value }) =>
        value === false ? 'پرداخت نشده' : 'پرداخت شده',
    },
  ];
  const _waybillType = {
    custom: 'سفارشی',
    police: 'پلیس راهی',
    software: 'کامل',
  };
  const getStatus = (status) => {
    let s = '';
    if (status) {
      s = 'قابل برداشت';
    } else if (!status) s = 'در انتظار تخلیه';
    else s = '';
    return s;
  };

  const payCommission = async () => {
    try {
      setLoadingDeposit(true);
      await axios.put(`api/v1/admin/reports/payCommissions`, {
        startDate: params.get('startDate'),
        endDate: params.get('endDate'),
        user: selectedUser.id,
        bank: values.bank.value,
        shebaNumber: values.shaba,
        refrenceNum: values.refrenceNum,
        depositDate: values.depositDate,
      });
      toast.success('تراکنش با موفقیت ثبت شد');

      refetchDeposits();
      setModal(false);
    } catch (error) {
      toast.error('تراکنش با خطا مواجه شد');
    } finally {
      setLoadingDeposit(false);
    }
  };

  const handleCloseModal = async (agree) => {
    if (agree === false) setModal(false);
    else {
      await payCommission();
      setModal(false);
    }
    setValues(initialValues);
  };

  const handlePageChange = (page) => {
    setParams([{ name: 'page', value: page }]);
  };
  const handleChangeBank = ({ label, value }) => {
    setValues({
      ...values,
      bank: { label, value },
    });
  };
  const handleChangeRefrenceNum = (e) => {
    const { value } = e.target;
    setValues({ ...values, refrenceNum: value });
  };
  const handleChangeShaba = (e) => {
    const { value } = e.target;
    setValues({ ...values, shaba: value });
  };
  const handleChangeDepositDate = (date) => {
    setValues({ ...values, depositDate: date });
  };
  const handleCellClick = async (selection) => {
    setValues({ ...values, amount: selection.value });
    statusTemp = await selection.row.status;
    if (selection.field == 'userCommissions') {
      if (statusTemp === false) {
        setSelectedUser(selection.row);
        setModal(true);
      } else toast.error('پرداخت شده است!');
    } else
      history.push(
        `/protected/admin/reports/commissions/custom/${
          selection.row.id
        }?startDate=${params.get('startDate')}&endDate=${params.get(
          'endDate'
        )}&page=${1}`
      );
  };

  async function getShebaNum() {
    try {
      const res = await axios.get(
        `/api/v1/admin/users/${selectedUser.id}/getShebaNumber`
      );
      const b = res.data.sheba?.[0]?.bank;
      const selectedBank = banks.find((bank) => bank.value === b) || {
        label: 'نام بانک',
        value: 0,
      };

      setValues({
        ...values,
        bank: selectedBank,
        shaba: res?.data?.sheba?.[0]?.shebaNumber || '',
      });
    } catch (error) {
      toast.error(error);
    }
  }

  const fetchDeposits = async () => {
    try {
      const res = await axios.get(
        `/api/v1/admin/reports/getCommissionPaymentReport${window.location.search}`
      );
      return res;
    } catch (error) {
      toast.error(error);
    }
  };

  const { data, isLoading, refetch: refetchDeposits } = useQuery(
    ['commissionReports', window.location.search],
    () => fetchDeposits(),
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(async () => {
    selectedUser.id && getShebaNum();
  }, [selectedUser]);

  var _reports = data?.data?.docs?.map((report, i) => ({
    id: report?.user?._id,
    rowNumber: (page - 1) * (limit * 1) + i + 1,
    orderCount: report?.count || '',
    userName: `${report.user.firstName} ${report.user.lastName}`,
    companyCommissions: formatNumber(report?.footabCommission) || '',
    userCommissions: formatNumber(report?.userCommission) || '',
    status: report?.isPaid ? true : false,
  }));

  return (
    <>
      <YesNo
        PaperProps={{
          style: { height: '80vh' },
        }}
        title={`پرداخت پورسانت : ${selectedUser.userName}`}
        yes="ذخیره"
        no="انصراف"
        inProgress={loadingDepostit}
        open={modal}
        onClose={handleCloseModal}
      >
        <div className={classes.form}>
          <SelectBank
            value={values.bank}
            onSelect={handleChangeBank}
            error={errors?.bank || false}
            helperText={errors?.bank ? 'بانک بایستی انتخاب شود' : ''}
          />

          <TextField
            name="shaba"
            value={values.shaba}
            onChange={handleChangeShaba}
            fullWidth
            variant="outlined"
            label="شماره شبا"
            size="small"
            error={errors?.shaba || false}
            helperText={errors?.shaba ? 'شماره شبا الزامیست' : ''}
            onBlur={validate}
          />
          <TextField
            name="refrenceNum"
            value={values.refrenceNum}
            onChange={handleChangeRefrenceNum}
            fullWidth
            variant="outlined"
            label="شماره مرجع"
            size="small"
            type="number"
            error={errors?.refrenceNum || false}
            helperText={errors?.refrenceNum ? 'شماره مرجع الزامیست' : ''}
            onBlur={validate}
          />
          <DatePicker
            label="تاریخ واریز"
            value={values.depositDate}
            onChange={handleChangeDepositDate}
            format={'jYYYY/jM/jD'}
          />
        </div>
      </YesNo>
      {/* <Button
          disabled={loadingDepostit}
          startIcon={<SaveIcon />}
          style={{
            backgroundColor: 'green',
            color: 'white',
            width: 'fit-content',
          }}
          // onClick={handleDownloadExcel}
        >
          {loadingExcel ? (
            <CircularProgress color="white" size={20} />
          ) : (
            ' دانلود اکسل گزارشات'
          )}
        </Button> */}

      <div
        className={classes.root}
        style={isMobile ? {} : { height: 850 }}
        ref={ref}
      >
        {isLoading ? (
          <LinearProgress />
        ) : (
          <DataGrid
            rows={isLoading ? [] : _reports}
            columns={columns}
            localeText={localText}
            pageNumber={params.get('page') * 1 || 1}
            pageSize={limit}
            rowCount={data?.totalDocs || 0}
            paginationMode="server"
            onPageChange={handlePageChange}
            loading={isLoading}
            disableMultipleSelection
            onCellClick={handleCellClick}
            density="compact"
            footerPagination
            // onSelectionChange={handleSelectRow}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(List);
